import { gql } from "urql";
export const CreateTherapyCategoryMutation = gql `
    mutation CreateTherapyCategory($name: String!) {
        therapyCategories {
            createTherapyCategory(name: $name) {
                therapyCategoryId
                name
                isActive
            }
        }
    }
`;
export const UpdateTherapyCategoryMutation = gql `
    mutation UpdateTherapyCategory(
        $therapyCategoryId: String!
        $name: String
        $isActive: Boolean
    ) {
        therapyCategories {
            updateTherapyCategory(
                therapyCategoryId: $therapyCategoryId
                name: $name
                isActive: $isActive
            ) {
                therapyCategoryId
                name
                isActive
            }
        }
    }
`;
export const DeleteTherapyCategoryMutation = gql `
    mutation DeleteTherapyCategory($therapyCategoryId: String!) {
        therapyCategories {
            deleteTherapyCategory(therapyCategoryId: $therapyCategoryId) {
                therapyCategoryId
            }
        }
    }
`;
export const CreateTherapySubCategoryMutation = gql `
    mutation CreateTherapySubCategory(
        $therapyCategoryId: String!
        $name: String!
    ) {
        therapySubCategories {
            createTherapySubCategory(
                therapyCategoryId: $therapyCategoryId
                name: $name
            ) {
                therapySubCategoryId
                name
                isActive
            }
        }
    }
`;
export const UpdateTherapySubCategoryMutation = gql `
    mutation UpdateTherapySubCategory(
        $therapySubCategoryId: String!
        $therapyCategoryId: String
        $name: String
        $isActive: Boolean
    ) {
        therapySubCategories {
            updateTherapySubCategory(
                therapySubCategoryId: $therapySubCategoryId
                therapyCategoryId: $therapyCategoryId
                name: $name
                isActive: $isActive
            ) {
                therapySubCategoryId
                name
                isActive
            }
        }
    }
`;
export const DeleteTherapySubCategoryMutation = gql `
    mutation DeleteTherapySubCategory($therapySubCategoryId: String!) {
        therapySubCategories {
            deleteTherapySubCategory(
                therapySubCategoryId: $therapySubCategoryId
            ) {
                therapySubCategoryId
            }
        }
    }
`;
